import { RequestDefinitionLayoutType } from '../../services';

export const defaultAuthorizedAgentData = {
  fields: [],
  translations: {},
  texts: [],
  layout: RequestDefinitionLayoutType.Default,
};
